// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact Page Styles */
* {
  box-sizing: border-box;
  margin: 0;
}

/* Get in Touch Section - Desktop Default */
.scl--web-page-contact-get-in-touch-section {
   background: #000000;
   width: 100%;
   min-height: 500px;
}
.scl--web-page-contact-contact-section{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding: 120px var(--global-desktop-padding-left);
  max-width: var(--global-desktop-width-resp);
  margin: 0 auto;
  position: relative;
  overflow: hidden;

}

.scl--web-page-contact-gradient-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  mix-blend-mode: normal;
  border-radius: 0px;
  z-index: 0;
}

/* Title Section */
.scl--web-page-contact-title-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 150px;
  z-index: 2;
}

.scl--web-page-contact-title-section-content {
  width: 100%;
}
 .scl--web-page-contact-cards-wrapper .scl--web-component-contact-card-description{
    padding-right: 10px;
      width: 100%;
    font-size: 18px;
    padding-bottom: 20px;
  }

.scl--web-page-contact-main-title {
  width: 100%;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 510;
  font-size: 70px;
  line-height: 150%;
  display: flex;
  align-items: center;
    background: linear-gradient(360deg, #A2A2A2 -108.76%, #ADADAD 10.54%, #DDDDDD 89.05%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-page-contact-subtitle {
  width: 100%;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 20px;
  line-height: 100%;
  color: #7D8187;
  margin: 0;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

/* Cards Wrapper */
.scl--web-page-contact-cards-wrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  padding: 0px;
  gap: 36px;
  width: 100%;
  z-index: 2;
}

.scl--web-page-contact-cards-wrapper > *:not(:last-child) {
  border-right: 1px solid rgba(125, 129, 135, 0.3);
}

/* Footer Section */
.scl--web-page-contact-footer-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 140px;
  background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);
  position: relative;
  overflow: hidden;
  min-height: 200px;
}

.scl--web-page-contact-footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  z-index: 2;
}

.scl--web-page-contact-icon-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.scl--web-page-contact-copyright-text {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: #8C8C8C;
  margin: 0;
}

.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button{
  background: #282828;
  border: 1.5px solid #797979;
}

.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container:last-child .scl--web-component-contact-styled-button{
  background: transparent;
}

.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container:last-child .scl--web-component-contact-styled-button:hover{
  background: #FFFFFF1A;
  border: 1px solid white;
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/contact/css/contact.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA,2CAA2C;AAC3C;GACG,mBAAmB;GACnB,WAAW;GACX,iBAAiB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,iDAAiD;EACjD,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;CACC;IACG,mBAAmB;MACjB,WAAW;IACb,eAAe;IACf,oBAAoB;EACtB;;AAEF;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;IACjB,qFAAqF;EACvF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gDAAgD;AAClD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":["/* Contact Page Styles */\n* {\n  box-sizing: border-box;\n  margin: 0;\n}\n\n/* Get in Touch Section - Desktop Default */\n.scl--web-page-contact-get-in-touch-section {\n   background: #000000;\n   width: 100%;\n   min-height: 500px;\n}\n.scl--web-page-contact-contact-section{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: start;\n  padding: 120px var(--global-desktop-padding-left);\n  max-width: var(--global-desktop-width-resp);\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n\n}\n\n.scl--web-page-contact-gradient-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  mix-blend-mode: normal;\n  border-radius: 0px;\n  z-index: 0;\n}\n\n/* Title Section */\n.scl--web-page-contact-title-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  margin-bottom: 150px;\n  z-index: 2;\n}\n\n.scl--web-page-contact-title-section-content {\n  width: 100%;\n}\n .scl--web-page-contact-cards-wrapper .scl--web-component-contact-card-description{\n    padding-right: 10px;\n      width: 100%;\n    font-size: 18px;\n    padding-bottom: 20px;\n  }\n\n.scl--web-page-contact-main-title {\n  width: 100%;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 510;\n  font-size: 70px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n    background: linear-gradient(360deg, #A2A2A2 -108.76%, #ADADAD 10.54%, #DDDDDD 89.05%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-page-contact-subtitle {\n  width: 100%;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 20px;\n  line-height: 100%;\n  color: #7D8187;\n  margin: 0;\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n/* Cards Wrapper */\n.scl--web-page-contact-cards-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  padding: 0px;\n  gap: 36px;\n  width: 100%;\n  z-index: 2;\n}\n\n.scl--web-page-contact-cards-wrapper > *:not(:last-child) {\n  border-right: 1px solid rgba(125, 129, 135, 0.3);\n}\n\n/* Footer Section */\n.scl--web-page-contact-footer-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 140px;\n  background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);\n  position: relative;\n  overflow: hidden;\n  min-height: 200px;\n}\n\n.scl--web-page-contact-footer-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  z-index: 2;\n}\n\n.scl--web-page-contact-icon-bar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  width: 100%;\n}\n\n.scl--web-page-contact-copyright-text {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  text-align: center;\n  color: #8C8C8C;\n  margin: 0;\n}\n\n.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-styled-button{\n  background: #282828;\n  border: 1.5px solid #797979;\n}\n\n.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container:last-child .scl--web-component-contact-styled-button{\n  background: transparent;\n}\n\n.scl--web-page-contact-get-in-touch-section .scl--web-component-contact-card-container:last-child .scl--web-component-contact-styled-button:hover{\n  background: #FFFFFF1A;\n  border: 1px solid white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
